<template>
  <div>
    <el-row :gutter="20">
      <el-col class="integration-settings" :span="24">
        <div>
          <div v-if="integrationWizardIndex >= 1">
            <h3 v-if="integrationWizardIndex == 1" class="cnct-aws-header">Connect AWS Account to Confluera</h3>            
            <h3 v-if="integrationWizardIndex == 2" class="cnct-aws-header">Success!</h3>
            <h3 v-if="integrationWizardIndex == 3" class="cnct-aws-header">Error!</h3>

            <el-steps
              v-if="integrationWizardIndex <= 2"
              class="el-step-fixes"
              :active="integrationWizardIndex"
              :finish-status="apiCall.error? 'error': 'success'"
            >
              <el-step></el-step>
              <el-step></el-step>
            </el-steps>

          </div>
          <el-carousel
            ref="wizard"
            :autoplay="false"
            :loop="false"
            indicator-position="none"
            arrow="never"
            height="400"
          >
            <el-carousel-item style="overflow: unset" :key="1">
              <span class="cnct-aws-header" style="margin-bottom: 22px">Connect to AWS Account</span>
              <p class="top-header">
                This wizard walks you through the simple steps to connect Confluera CxDR to your AWS account. If you
                have multiple AWS accounts, simply run this wizard to configure each account.
              </p>

              <el-row type="flex" :gutter="24" style="margin: -32px 0px 0px;">
                <el-col :span="4" class="integration-logo-container">
                  <el-card shadow="hover" class="integration-logo-card">
                    <span class="display-block" style="margin-top: 14px; margin-left: 6px">
                      <img style="margin-top: 20px" src="/static/images/aws-color.svg" alt="aws logo"/>
                    </span>
                  </el-card>
                </el-col>
                <el-col :span="20" class="connect-aws">
                  <el-row>
                    <el-row>
                      <el-col :span="23"><span class="bold">Step 1</span></el-col>
                    </el-row>
                    <el-row>
                      <el-col :span="23">
                        On the AWS console, configure a role ARN for Confluera CxDR to connect to your AWS account.
                      </el-col>
                      <el-col>
                        <span class="text-btn" @click="loadDocumentation('page-cloud-aws')"> Learn More </span>
                      </el-col>
                    </el-row>
                  </el-row>
                  <br />
                  <el-row>
                    <el-row>
                      <el-col :span="23"><span class="bold">Step 2</span></el-col>
                    </el-row>
                    <el-row>
                      <el-col :span="23">Use this wizard to connect to your AWS account using the AWS role ARN</el-col>
                    </el-row>
                    <el-col :span="23"
                      ><br /><br />
                      *NOTE: <br />
                      Confluera’s Account ID: 347227527012 <br />
                      External ID: a345aj-sxsax-1jwdewdw
                    </el-col>
                  </el-row>
                </el-col>
              </el-row>
            </el-carousel-item>
            <el-carousel-item style="overflow: unset" :key="2">
              <div class="header-carousal-2">
                Enter the AWS role ARN and other preferred connection settings to setup the AWS account connection
              </div>
              <div class="box flex">
                <el-form :v-model="integrationWizardForm" label-width="240px" label-position="left" class="full-width">
                  <el-row :type="'flex'" :gutter="8" class="mt-20">
                    <el-col>
                      <el-row :gutter="20">
                        <el-col :span="8" class="conf-block">
                          <el-form-item label="Account Nickname"></el-form-item>

                          <el-input
                            v-model="integrationWizardData.nickName"
                            placeholder="Enter a nickname for your connection"
                            @keydown.native.space.prevent
                          ></el-input>
                        </el-col>

                        <el-col :span="8" class="conf-block">
                          <el-form-item label="Confluera Role ARN"></el-form-item>

                          <el-input
                            v-model="integrationWizardData.roleArn"
                            placeholder="Enter your role ARN"
                          ></el-input>
                        </el-col>

                        <el-col :span="8" class="conf-block">
                          <el-form-item label="External ID"></el-form-item>

                          <el-input
                            v-model="integrationWizardData.externalId"
                            placeholder="Enter the External ID"
                          ></el-input>
                        </el-col>

                        <el-col :span="8" class="conf-block">
                          <el-form-item label="Scan Frequency"></el-form-item>
                          <el-select
                            style="width: 100%"
                            v-model="integrationWizardData.scanFrequency"
                            placeholder="Select Frequency"
                          >
                            <el-option
                              v-for="item in [
                                { label: '1 Minute', value: 60000 },
                                { label: '3 Minute', value: 60000 * 3 },
                                { label: '5 Minute', value: 60000 * 5 }
                              ]"
                              :key="item.value"
                              :label="item.label"
                              :value="item.value"
                            >
                            </el-option>
                          </el-select>
                        </el-col>
                      </el-row>
                    </el-col>
                  </el-row>
                </el-form>
              </div>
            </el-carousel-item>
            <el-carousel-item style="overflow: unset" :key="3" class="initiated mt-20">              
              <div>
                <img src="/static/images/gcpSuccess.svg" alt="SUCCESS" />
              </div>
              <div class="initiated_message">
                <span>You've added your AWS Account assets. Now you'll be</span><br>
                <span>able to observe them in one secure environmemt.</span>
              </div>
              <div class="mt-25">
                <el-button
                type="primary"
                size="medium"
                style="background-color: #1A90FA;"
                @click="gotoDiscoveryIntegrationWorkflow"
               >Cloud Accounts</el-button>
              </div>
              <div class="initiated_message mt-20">
                <span>You can now add <strong>Kubernetes</strong> for your AWS Account.</span>
                <router-link class="display-block" style="width: 14%" :to="{ name: 'installation', query: { os: 'kubernetes' } }">
                  <a>Set up Kubernetes</a>
                </router-link><br>
                <span>View <strong>Discovered Instances</strong> for your AWS Account.</span>
                <router-link class="display-block" :to="{ name: 'hosts', query: { hostfilter: 'aws' } }">
                  <a>Discovered instances</a>
                </router-link>
              </div> 
            </el-carousel-item>
            <el-carousel-item :key="4" class="initiated error mt-20">              
              <div>
                <img src="/static/images/gcpError.svg" alt="ERROR" />
              </div>
              <div class="initiated_message mt-60">
                <span><b>Could Not Connect</b></span><br>
                <span>We could not connect to your AWS cloud account.</span><br>
                <span>Troubleshoot to fix your configuration.</span><br><br>
                <span>invalid-integration-config: the integration configuration was invalid.</span>
              </div>
              <div class="mt-89">
                <el-button
                type="primary"
                size="medium"
                style="background-color: #1A90FA;"
                @click="loadDocumentation('page-cloud-aws')"
               >Troubleshoot</el-button>
              </div>
            </el-carousel-item>
          </el-carousel>
          <div class="flex">
            <span
              v-if="[1, 3].includes(integrationWizardIndex)"
              class="text-underline cursor-pointer back-button go-back-button"
              @click="backIntegrationStep"
              >Back
            </span>
            <el-button
              class="start-button"
              v-if="integrationWizardIndex < 1"
              size="medium"
              round
              @click="nextIntegrationStep"
            >
              Start
            </el-button>
            <el-button
              class="submit-button"
              v-else-if="integrationWizardIndex == 1"
              size="medium"
              round
              @click="updateIntegrationSettings"
            >
              Submit
            </el-button>            
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import integrationFormMixin from '@/components/form/integrations/integrationFormMixin'
import { AWS_CONNECTION_SETTINGS_CREATE_REQUEST } from '@/store/modules/integrations/aws-connection-settings.type'
import loadDocumentationMixin from '@/mixins/loadDocumentationMixin'

export default {
  name: 'AwsIntegrationWorkflow',
  mixins: [integrationFormMixin, loadDocumentationMixin],
  data () {
    return {
      integrationWizardSteps: [
        'Go to IAM console->Roles',
        'Create new role',
        'Select "Another AWS Account"',
        'Put Account# of Confluera <347227527012>',
        'Put External ID# of Confluera <a345aj-sxsax-1jwdewdw>',
        'Select and attach two policies: AWSConfigRole policy and AWSConfigUserAccess policy',
        'Create role (e.g. ConfigAccessRole)'
      ],
      apiDispatchState: AWS_CONNECTION_SETTINGS_CREATE_REQUEST,
      apiCall: {
        outbound: false,
        error: false,
        errMsg: ''
      }
    }
  },
  created () {},
  computed: {
    ...mapGetters(['cloudIntegrationAccounts'])
  },
  watch: {},
  components: {}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import 'assets/styles/_variables.css';
@import 'assets/styles/integration_workflow.css';

.integration-settings {
  overflow: unset;
}

.initiated {
  h4 {
    margin-bottom: 40px;
  }

  p {
    text-align: center;
    width: 60%;
    margin: auto;
    display: block;
  }

  >>> .el-button {
    margin: auto;
  }

  >>> .el-icon-loading,
  .material-icons {
    font-size: 2em;
  }

  .center-text.error-icon {
    margin: auto;
    font-size: 2em;
  }
}

>>> .el-carousel--horizontal {
  overflow-x: hidden;
  width: 110%;
}

>>> .el-step__head.is-success {
  color: #1a90fa;
}

>>> .el-step__head {
  fill: #1a90fa;
  border-color: #1a90fa;
}

>>> .el-step__line {
  background-color: #1a90fa;
}

>>> .el-step__icon-inner {
  color: #1a90fa;
}

.el-form-item {
  margin-bottom: 0px;
}
.verify-details-box {
  border: 2px solid black;
  border-radius: 10px;
  margin-top: 4%;
  padding: 32px;
  height: 80%;
  overflow: auto;
}

.error-message {
  width: 60%;
  margin: 30px auto;

  p {
    width: 100%;
  }
}

.top-header {
  height: 94px;
  width: 834px;
  color: #454b60;
  font-size: 14px;
  letter-spacing: 0.17px;
  line-height: 22px;
}

.top-header-title {
  font-weight: 500px;
  font-size: 24px;
  margin-bottom: 22px;
}
.aws-content {
  height: 308px;
  width: 616px;
  color: #454b60;
  font-size: 14px;
  letter-spacing: 0;
  line-height: 22px;
}

.start-button {
  height: 36px;
  width: 113px;
  border-radius: 4px;
  background-color: #1a90fa;
  margin-left: 55%;
  text-align: center;
  margin-top: 50px;
}

.verify-button,
.submit-button {
  height: 36px;
  width: 113px;
  border-radius: 4px;
  background-color: #1a90fa;
  /* margin-left:55%; */
  text-align: center;
}

.go-back-button {
  height: 36px;
  width: 113px;
  border-radius: 4px;
  background-color: #ffffff;
  margin-left: 55%;
  text-align: center;
  border: 1px solid #767676;
  text-decoration: none;
}
.conf-block {
  display: inline-block;
  width: 34.86%;
  height: 27.34%;
  line-height: 20px;
  letter-spacing: 0.09px;
  font-size: 13px;
  font-weight: 500;
  margin-bottom: 50px;
}

.header-carousal-2 {
  height: 66px;
  width: 575px;
  color: #454b60;
  /* font-family: Montserrat; */
  font-size: 14px;
  letter-spacing: 0.1px;
  line-height: 22px;
}

.carousal-3-content {
  margin-bottom: 20px;
  font-size: 14px;
}

.integration-settings {
  .el-steps {
    padding: 20px 10px 25px 10px;
    margin: 0 0 20px 0;
    border-bottom: solid 1px #f0f0f0;
  }

  >>> .el-carousel {
    margin: 10px 0 30px 0;

    .el-carousel__container {
      height: 440px;
    }
  }
}

.cnct-aws-header {
  margin-bottom: 20px;
  margin-top: 10px;
  font-weight: 500px;
  font-size: 24px;
}

.el-step-fixes {
  width: 20%;
  padding-left: 0px;
  border: none;
}

.text-btn {
  cursor: pointer;
  color: #409eff;
}

.connect-aws {
  margin-left: 12px;
  width: 379px;
  height: 198px;
  font-size: 14px;
  letter-spacing: 0;
  line-height: 22px;
}
</style>



// WEBPACK FOOTER //
// src/components/form/integrations/AwsIntegrationWorkflow.vue